import React from 'react';
import ShopReceiptHeader from './common-includes/ShopReceiptHeader';
import ShopReceiptFooter from './common-includes/ShopReceiptFooter';
import { getLabel } from '../../../data/labels';
import { getConfiguration } from '../../utils/configuration';
import { getCurrencyValue } from '../../utils/getCurrencyValue';
import { getFormattedDateNow } from '../../utils/getFormattedDateNow';
import { getPrintableAmount } from '../../utils/getPrintableAmount';
import DetailedBalanceFooter from './common-includes/DetailedBalanceFooter';
import DetailedBalanceCss from './common-includes/DetailedBalanceCss';


function DailyShopDetailedBalance(props) {

	const conf = getConfiguration();
	const opData = props.data;
	const rowsData = {};
	// parsing rows
	for(let k in opData.rows){
		const initialRow = opData.rows[k];
		const mapKey = initialRow.terminalista;
		if(!rowsData[mapKey]){
			rowsData[mapKey] = {
				totalCashAv : 0,
				rows : []
			};
		}
		rowsData[mapKey].totalCashAv += initialRow.saldo_totale;
		rowsData[mapKey].rows.push(initialRow);
	}
	

	function HtmlRow(props){
		const toPrintValues = [];
		const row = props.row;
		if(row.venduto_num > 0){
			toPrintValues.push({
				operation : getLabel('retail.shop_detailed_balance.sold_tickets'),
				num : row.venduto_num,
				amount: getPrintableAmount(row.venduto_imp, conf.cs.m, conf.cs.nd)
			});
		}
		if(row.annullato_num > 0){
			toPrintValues.push({
				operation : getLabel('retail.shop_detailed_balance.voided_tickets'),
				num : row.annullato_num,
				amount: getPrintableAmount(row.annullato_imp, conf.cs.m, conf.cs.nd)
			});
		}
		if(row.pagato_num > 0){
			toPrintValues.push({
				operation : getLabel('retail.shop_detailed_balance.paid_tickets'),
				num : row.pagato_num,
				amount: getPrintableAmount(row.pagato_imp, conf.cs.m, conf.cs.nd)
			});
		}
		
		if(row.rimborsato_num > 0){
			toPrintValues.push({
				operation : getLabel('retail.shop_detailed_balance.rembursed_tickets'),
				num : row.rimborsato_num,
				amount: getPrintableAmount(row.rimborsato_imp, conf.cs.m, conf.cs.nd)
			});
		}
		
		if(row.sovvenzione_num > 0){
			toPrintValues.push({
				operation : getLabel('retail.shop_detailed_balance.grant_cash_op'),
				num : row.sovvenzione_num,
				amount: getPrintableAmount(row.sovvenzione_imp, conf.cs.m, conf.cs.nd)
			});
		}
		
		if(row.restituzione_num > 0){
			toPrintValues.push({
				operation : getLabel('retail.shop_detailed_balance.returning_cash_op'),
				num : row.restituzione_num,
				amount: getPrintableAmount(row.restituzione_imp, conf.cs.m, conf.cs.nd)
			});
		}
		
		if(row.voucher_emessi_num > 0){
			toPrintValues.push({
				operation : getLabel('retail.shop_detailed_balance.emitted_vouchers'),
				num : row.voucher_emessi_num,
				amount: getPrintableAmount(row.voucher_emessi_imp, conf.cs.m, conf.cs.nd)
			});
		}
		
		if(row.voucher_pagati_num > 0){
			toPrintValues.push({
				operation : getLabel('retail.shop_detailed_balance.paid_vouchers'),
				num : row.voucher_pagati_num,
				amount: getPrintableAmount(row.voucher_pagati_imp, conf.cs.m, conf.cs.nd)
			});
		}
		
		if(row.voucher_resto_num > 0){
			toPrintValues.push({
				operation : getLabel('retail.shop_detailed_balance.rest_vouchers'),
				num : row.voucher_resto_num,
				amount: getPrintableAmount(row.voucher_resto_imp, conf.cs.m, conf.cs.nd)
			});
		}
		if(row.voucher_inseriti_num > 0){
			toPrintValues.push({
				operation : getLabel('retail.shop_detailed_balance.used_vouchers'),
				num : row.voucher_inseriti_num,
				amount: getPrintableAmount(row.voucher_inseriti_imp, conf.cs.m, conf.cs.nd)
			});
		}
		if(row.cash_num > 0){
			toPrintValues.push({
				operation : getLabel('retail.shop_detailed_balance.cashout_tickets'),
				num : row.cash_imp,
				amount: getPrintableAmount(row.cash_imp, conf.cs.m, conf.cs.nd)
			});
		}
		let protocolDescription = row.protocollo;
		let labelTot = 'Tot ' + row.protocollo;
		switch(row.protocollo.toUpperCase()){
		case 'PSQF':
            protocolDescription = getLabel('retail.protocol.psqf_desc');
            labelTot = getLabel('retail.shop_detailed_balance.cash_availability_sport');
            break;
		case 'PSV':
            protocolDescription = getLabel('retail.protocol.psv_desc');
            labelTot = getLabel('retail.shop_detailed_balance.cash_availability_virtual');
            break;
		case 'CASSA':
            protocolDescription = getLabel('retail.shop_detailed_balance.cash_movs');
            labelTot = getLabel('retail.shop_detailed_balance.cash_availability_cash_movs');
            break;
        default:
            break;
		}
		return <>
			<div className={"headerRow"}> 
				<div className={"headerRowChild protocolName"}> {protocolDescription.toUpperCase()} </div>
				<div className={"headerRowChild"}> {row.tipo_terminale} {row.numero_client} </div>
			</div>
			
			{
				Object.keys(toPrintValues).map((key)=> {
					const value = toPrintValues[key];
					return <div className={"bodyRow"} key={key}>
						<div className={"bodyRowChild operationDesc"}> { "- " + value.operation} </div>
						<div className={"bodyRowChild operationNumber"}> {getLabel('retail.shop_detailed_balance.op_num') + ' ' + value.num} </div>
						<div className={"bodyRowChild operationAmount"}> {getLabel('retail.shop_detailed_balance.tot') + ' ' + value.amount} </div>
					</div>
				})
			}
			
			
			<div className="operationMonospace cashAvailability">
			 	{labelTot}: 
			 	{getCurrencyValue(row.saldo_totale, conf.cs.m, conf.cs.nd, conf.cs.ct)} 
			</div>

			{
				props.index < props.totalLength &&
					<div className={"hr-line-dashed"}></div>		
			}
			
			
		</>;
	}
	
	function Header(props){
		const opData = props.opData;
		const operator = props.operator;
		return <>
			<div> {getLabel('retail.date_time')}: {getFormattedDateNow().formatted} </div>
			<div> {getLabel('retail.shop_detailed_balance.pos_id')}: {operator.shopId} </div>
			<div className="headerBox">
			{
			/*
				<div className="operationMonospace"> 
					{getLabel('retail.shop_detailed_balance.prior_availability')}: 
					{getCurrencyValue(opData.header.previousBalance, conf.cs.m, conf.cs.nd, conf.cs.ct)} 
				</div>
			 */
			}

				<div className="operationMonospace"> 
					{getLabel('retail.shop_detailed_balance.default_limit')}: 
					{getCurrencyValue(opData.header.defaultLimit, conf.cs.m, conf.cs.nd, conf.cs.ct)} 
				</div>
				<div className="operationMonospace"> 
					{getLabel('retail.shop_detailed_balance.total_cash_availability')}: 
					{getCurrencyValue(opData.header.totalCashAvailability, conf.cs.m, conf.cs.nd, conf.cs.ct)} 
				</div>
				<div className="operationMonospace"> 
					{getLabel('retail.shop_detailed_balance.current_pos_limit')}: 
					{getCurrencyValue(opData.header.currentPosLimit, conf.cs.m, conf.cs.nd, conf.cs.ct)} 
				</div>
			</div>
		</>
	}
	
	return <>
		<DetailedBalanceCss />
		<body>
			<ShopReceiptHeader customerLogo={props.customerLogo} aamsLogo={props.aamsLogo} operationTitle={getLabel('retail.operator_menu.daily_detailed_balance_shop_extended') + ' ' + opData.operator.shopDescr}></ShopReceiptHeader>	
			<Header opData={opData} operator={props.data.operator} />
			{	
				Object.keys(rowsData).map((key)=> {
					const rows = rowsData[key].rows;
					return <div className="rowBox" key={key}>
					
						<div className={"operatorName"}> {key} </div>
						{
							Object.keys(rows).map((keyRow) => {
								return <HtmlRow key={"rowKey-" + keyRow} row={rows[keyRow]} totalLength={rows.length} index={parseInt(keyRow) + 1}/>
							})
						}
						<div className="operationMonospace totalCashAvailability"> 
							{getLabel('retail.shop_detailed_balance.total_cash_availability')}: 
							{getCurrencyValue(rowsData[key].totalCashAv, conf.cs.m, conf.cs.nd, conf.cs.ct)} 
						</div>
					</div>
				})
			}
			<DetailedBalanceFooter footer={opData.footer} showSummaryLabel={true} />	
			<ShopReceiptFooter></ShopReceiptFooter>
		</body>
    </>;
}

export default DailyShopDetailedBalance;